import { forwardRef, InputHTMLAttributes, useEffect, useState } from "react";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { searchCepCorreiosURL } from "../../Constants";
import { FiInfo } from "react-icons/fi";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelColor?: string;
  labelSize?: string;
  labelWeight?: string;
  errorMessage?: string;
  toolTipText?: string;
  requiredMark?: boolean;
  containerClassName?: string;
  isNumeric?: boolean;
  showPasswordInstructions?: boolean;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({
  label,
  errorMessage,
  toolTipText,
  requiredMark,
  containerClassName,
  value,
  onChange,
  isNumeric,
  showPasswordInstructions = false,
  labelColor = "gray-700",
  labelSize = "base",
  labelWeight = "semibold",
  ...rest
}, ref) => {
  const [hasValue, setHasValue] = useState(false);

  // Cria um ID único com base no label
  const tooltipId = `tooltip-${label && label.replace(/\s+/g, "-").toLowerCase()}`;

  useEffect(() => {
    setHasValue(!!value);
  }, [value]);




  return (
    <div className={`w-full ${containerClassName}`}>
      <label className={`text-${labelSize} font-${labelWeight} text-${labelColor} flex items-center gap-1`}>
        {label && label}
        {requiredMark && <span className="text-red-500 font-bold">*</span>}
        {toolTipText && (
          <>
            <FiInfo
              className="text-blue-500 hover:text-white hover:bg-blue-500 rounded-full cursor-pointer ml-1"
              data-tooltip-id={tooltipId}
            />
            <ReactTooltip
              id={tooltipId}
              place="top"
              content={toolTipText}
              className="z-50"
            />
          </>
        )}
        {
          label && label.toLowerCase().includes('cep') && (
            <a
              className="text-sky-600 text-xs lg:text-sm ml-1"
              href={searchCepCorreiosURL}
              target="_blank"
            >
              Buscar Cep
            </a>
          )
        }
      </label>

      <div className="flex">
        <input
          type="text"
          ref={ref}
          value={value}
          onChange={(e) => {
            onChange?.(e);
            setHasValue(!!e.target.value);
          }}
          className={`w-full px-4 mt-1 py-2 h-[42px] rounded-lg border bg-white disabled:cursor-not-allowed
                      ${errorMessage ? "border-red-500" : "border-gray-300"}
                      placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-300
                      ${hasValue ? "text-gray-700" : "text-gray-400"} ${!label && "mt-[28px]"}${isNumeric ? " text-right" : ""} disabled:opacity-50`}
          {...rest}

        />
      </div>

      {
        showPasswordInstructions && label && label.toLowerCase().includes('senha') && (
          <div className="mt-1 w-full max-w-full">
            <p className="
              text-xs md:text-sm text-center text-gray-500 leading-5
              w-full max-w-full break-words whitespace-normal overflow-hidden
              px-1
            ">
              A senha precisa ter pelo menos 8 caracteres, com uma letra maiúscula, um número
              e um símbolo (!, @, #, $, %, ^, *, &).
            </p>
          </div>
        )
      }

      {errorMessage && (
        <p className="text-red-500 text-sm mt-1">{errorMessage}</p>
      )}
    </div>
  );
});

TextInput.displayName = "TextInput";